// import Spinner from 'react-bootstrap/Spinner';

import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useState } from "react";

function LoadingComponent({ Loading, canClose = false }) {
  const Mostrar = () => {
    const [open, setOpen] = useState(Loading === true);

    if (Loading) {
      return (
        <Dialog
          open={open}
          PaperProps={{
            style: { padding: 20, textAlign: "center", minWidth: 300 },
          }}
          onClick={() => (canClose ? setOpen(!open) : null)}
        >
          <DialogTitle>
            <img
              alt="loading"
              src="/tav-loading.gif"
              style={{ maxWidth: 70 }}
            />
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Typography variant="h6" fontWeight={"bold"}>
                Cargando información...
              </Typography>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      );
    }
  };

  return <Mostrar />;
}

export default LoadingComponent;
